import {
  call,
  cancel,
  debounce,
  fork,
  put,
  take,
  takeEvery,
  select,
} from 'redux-saga/effects';
import { history } from '../modules/history';

import { request } from './api';
import { onLoginChange } from './login';
import { getLoggedIn } from '../selectors/user';
import {
  unreadCountRequested,
  archivedCountRequested,
} from '../actions/conversations';
import {
  MESSAGE_CREATED,
  MESSAGE_CREATED_V1,
  MESSAGE_MARKED_READ,
  MESSAGES_READ,
} from '../constants/actions.realtime';
import {
  BOOKING_CONVERSATION_REDIRECTED,
  SOCKET_READY,
} from '../constants/action-types';

function* refreshUnreadCount(action = null) {
  if (action && !action.__FROM_SOCKET__) {
    return;
  }
  yield put(unreadCountRequested());
}

function* refreshArchivedCount(action = null) {
  if (action && !action.__FROM_SOCKET__) {
    return;
  }
  yield put(archivedCountRequested());
}

function* getUnreadCount() {
  yield take(SOCKET_READY);
  yield call(refreshUnreadCount);
  yield call(refreshArchivedCount);
  yield debounce(
    500,
    [MESSAGE_CREATED, MESSAGE_CREATED_V1, MESSAGES_READ, MESSAGE_MARKED_READ],
    refreshUnreadCount
  );
}

function* getUnreadCountLoop() {
  let task = null;

  // Check if user is already logged in on app start
  const initialLoggedIn = yield select(getLoggedIn);

  if (initialLoggedIn) {
    // User is already logged in, start listening for SOCKET_READY immediately
    task = yield fork(getUnreadCount);
  }

  while (true) {
    const loggedIn = yield call(onLoginChange);

    if (task) {
      yield cancel(task);
      task = null;
    }

    if (loggedIn) {
      task = yield fork(getUnreadCount);
    }
  }
}

export function* redirectBookingToConversation({ bookingId }) {
  const conversation = yield call(request, {
    url: `/bookings-v2/${bookingId}/getConversation`,
  });

  if (conversation) {
    yield call(history.push, `/messages/${conversation.uuid}`);
  }
}

export default function* conversationsSaga() {
  yield fork(getUnreadCountLoop);
  yield takeEvery(
    BOOKING_CONVERSATION_REDIRECTED,
    redirectBookingToConversation
  );
}
